export const SESSION_TIMEOUT_MS = 30 * 60 * 1000;
const LANDING_CONTEXT_KEY = 'miskipop_analytics_landing_context';

export const PRIVATE_ANALYTICS_PREFIXES = ['/admin', '/influencer', '/my-account', '/customer', '/checkout'];

export function isPublicAnalyticsPath(pathname = '') {
  return !PRIVATE_ANALYTICS_PREFIXES.some((prefix) => pathname === prefix || pathname.startsWith(`${prefix}/`));
}

export function normalizeAnalyticsPath(pathname = '/', search = '') {
  const path = pathname || '/';
  const params = new URLSearchParams(search);
  const safeUtm = ['utm_source', 'utm_medium', 'utm_campaign', 'utm_term', 'utm_content']
    .filter((key) => params.has(key))
    .map((key) => `${key}=${encodeURIComponent(params.get(key))}`);
  return safeUtm.length ? `${path}?${safeUtm.join('&')}` : path;
}

export function setAnalyticsLandingContext(context) {
  if (!context?.landingPageId || !context?.influencerProfileId) return;
  sessionStorage.setItem(LANDING_CONTEXT_KEY, JSON.stringify(context));
}

export function getAnalyticsLandingContext() {
  try {
    return JSON.parse(sessionStorage.getItem(LANDING_CONTEXT_KEY) || 'null');
  } catch {
    return null;
  }
}
